import React from 'react';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Box from '@mui/material/Box';

export type TControlledInputProps<T extends FieldValues> = TextFieldProps &
  UseControllerProps<T> & {
    errorMessage?: string;
  };

export const TextFieldWrapper = <T extends FieldValues>({
  name,
  control,
  errorMessage,
  ...props
}: TControlledInputProps<T>) => {
  const { field } = useController<T>({ control, name });

  return (
    <Box>
      <TextField
        {...field}
        {...props}
        helperText={errorMessage}
        fullWidth
        sx={(theme) => ({
          '& .MuiInputBase-input': {
            border: errorMessage ? '1px solid' : 'none',
            borderColor: errorMessage ? theme.palette.error.main : 'transparent',
            borderRadius: '8px',
          },
          '& .MuiFormLabel-root': {
            color: '#000',
            '&.Mui-focused': {
              color: '#000',
            },
          },
        })}
      />
    </Box>
  );
};
